export * from './translate.service';
export * from './translations';
export * from './translate.pipe';



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/translate/index.ts